<template>
  <v-container class="login-required">
    <v-row>
      <v-col cols="12" md="12">
        <div class="text-center pt-16">
          <h2>You should sign in to see the content</h2>
          <p class="pt-7">
            <v-btn
              @click="showLogin"
              color="#f0b323">
              Sign in
            </v-btn>
          </p>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'login-required',
  computed: {
    isAccess () {
      return this.$store.getters['tokens/isAccessToken']
    },
    isChecked () {
      return this.$store.getters['tokens/isTokenChecked']
    }
  },
  methods: {
    showLogin () {
      this.$store.dispatch('modals/showModal', 'login')
    }
  },
  watch: {
    isChecked (v) {
      if (v && !this.isAccess) {
        this.$store.dispatch('modals/showModal', 'login')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.login-required {
  position: relative;
  padding: 50px 0px;
  min-height: 400px;
  background: #fff;
}
</style>
